import React, { useEffect, useState } from "react";
import { Box, Badge, Button, Divider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MotionWrapper from "../../../../components/MotionWrapper";
import { Icon } from "@iconify/react";
import { getPendingEditRequestCount } from "../../../../redux/features/appraisalSlice";

const AppraisalRootLayout = ({ data, reportingHead = false, state }) => {
  const { sectionName, setSectionName, viewType, setViewType } = state;
  const dispatch = useDispatch();
  const { pendingEditRequestCount } = useSelector((state) => state.appraisal);

  useEffect(() => {
    if (data.length > 0) {
      setSectionName(data[0] || {});
    }
  }, [viewType]);

  // Badges the "Team Data" toggle so a pending edit request doesn't rely on
  // the reporting head stumbling onto it while browsing.
  useEffect(() => {
    if (reportingHead) {
      dispatch(getPendingEditRequestCount());
    }
  }, [reportingHead, dispatch]);

  return (
    <Box>
      {/* Conditional Header Buttons */}
      {reportingHead && (
        <MotionWrapper directions="left" delay={0.2}>
          <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
            <Button
              size="small"
              sx={{
                borderRadius: 4,
                backgroundColor: viewType === 1 ? "#103996" : "#1039962e",
                color: viewType === 1 ? "#fff" : "#103996",
                "&:hover": {
                  backgroundColor: "#103996",
                  boxShadow: "none",
                  color: "#fff",
                },
              }}
              onClick={() => setViewType(1)}
            >
              <Icon icon="fluent:person-16-regular" width="16" height="16" />
              My Data
            </Button>
            <Badge
              badgeContent={pendingEditRequestCount}
              color="error"
              overlap="rectangular"
              sx={{ "& .MuiBadge-badge": { right: 6, top: 4 } }}
            >
              <Button
                size="small"
                sx={{
                  borderRadius: 4,
                  backgroundColor: viewType === 2 ? "#103996" : "#1039962e",
                  color: viewType === 2 ? "#fff" : "#103996",
                  "&:hover": {
                    backgroundColor: "#103996",
                    boxShadow: "none",
                    color: "#fff",
                  },
                }}
                onClick={() => setViewType(2)}
              >
                <Icon icon="f7:person-3" width="20" height="20" /> Team Data
              </Button>
            </Badge>
          </Box>
        </MotionWrapper>
      )}

      {/* Tab Buttons */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 1,
          overflowX: "auto",
          whiteSpace: "nowrap",
          paddingBottom: 1,
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {data.map((item, i) => (
          <Box key={i} sx={{ pt: 0.4 }}>
            <MotionWrapper directions={"bottom"} delay={i * 0.1}>
              <Button
                key={item.tabName}
                size="small"
                sx={{
                  borderRadius: 4,
                  boxShadow: "none",
                  flexShrink: 0,
                  height: 25,
                }}
                variant={
                  sectionName.tabName === item.tabName
                    ? "contained"
                    : "outlined"
                }
                onClick={() => setSectionName(item)}
              >
                {item.tabName}
              </Button>
            </MotionWrapper>
          </Box>
        ))}
      </Box>
      <Divider />

      {/* Active Tab Content */}
      <Box mt={1}>
        {reportingHead && viewType === 2 && sectionName.teamComponent
          ? React.cloneElement(sectionName.teamComponent, { state })
          : sectionName.component &&
            React.cloneElement(sectionName.component, { state })}
      </Box>
    </Box>
  );
};

export default AppraisalRootLayout;
